import {
  BoltOutlined,
  CalendarTodayOutlined,
  QueryBuilderOutlined,
  VideocamOutlined,
} from '@mui/icons-material';
import { hireflixCta } from '@styles/colors';
import React from 'react';

export const hireflixFeatures = [
  {
    id: 1,
    icon: React.createElement(BoltOutlined, { sx: { color: hireflixCta } }),
    title: 'Build once, invite many',
    description:
      'Create one interview template and send it to unlimited candidates',
  },
  {
    id: 2,
    icon: React.createElement(CalendarTodayOutlined, {
      sx: { color: hireflixCta, fontSize: '20px' },
    }),
    title: 'No scheduling needed',
    description:
      'Candidates record on their schedule, eliminating back-and-forth coordination',
  },
  {
    id: 3,
    icon: React.createElement(QueryBuilderOutlined, {
      sx: { color: hireflixCta, fontSize: '22px' },
    }),
    title: 'Review on your schedule',
    description:
      "Watch and evaluate interviews whenever it's convenient for you",
  },
  {
    id: 4,
    icon: React.createElement(VideocamOutlined, { sx: { color: hireflixCta } }),
    title: 'Faster, smarter hiring',
    description:
      'Screen more candidates in less time with consistent interview questions',
  },
];
